export const fmt = (n) => `${n.toLocaleString("fr-FR")} FCFA`;

export const makeRef = (prefix, from, to) => {
  const d = new Date();
  const dd = `${String(d.getDate()).padStart(2, "0")}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getFullYear()).slice(-2)}`;
  return `${prefix}-${from}-${to}-${dd}-${Math.floor(1000 + Math.random() * 9000)}`;
};

export const AIRPORTS = [
  { code: "ABJ", city: "Abidjan" },
  { code: "BYK", city: "Bouaké" },
  { code: "SPY", city: "San-Pédro" },
  { code: "HGO", city: "Korhogo" },
];

export const FLIGHT_DAYS = [
  { id: "ven", label: "Ven. 27", price: 45000 },
  { id: "sam", label: "Sam. 28", price: 45000, default: true },
  { id: "dim", label: "Dim. 29", price: 48000 },
];

export const FLIGHTS = [
  { id: "hf301", airline: "Air Côte d'Ivoire", num: "HF 301", dep: "07:30", arr: "08:20", duration: "55 min", price: 45000, cls: "Éco" },
  { id: "hf303", airline: "Air Côte d'Ivoire", num: "HF 303", dep: "11:15", arr: "12:05", duration: "50 min", price: 50000, cls: "Éco" },
  { id: "hf305", airline: "Air Côte d'Ivoire", num: "HF 305", dep: "15:40", arr: "16:30", duration: "50 min", price: 50000, cls: "Éco" },
  { id: "hf307", airline: "Air Côte d'Ivoire", num: "HF 307", dep: "18:20", arr: "19:10", duration: "50 min", price: 55000, cls: "Éco" },
];

export const POPULAR_DESTS = [
  { code: "BYK", name: "Bouaké", price: 45000, img: "/aya/transport/tp_dest_bouake.jpg" },
  { code: "SPY", name: "San-Pédro", price: 52000, img: "/aya/transport/tp_dest_sanpedro.jpg" },
  { code: "HGO", name: "Korhogo", price: 52000, img: "/aya/transport/tp_dest_korhogo.jpg" },
];

export const FLIGHT_OPTIONS = { extraBag: 15000, seat: 5000, insurance: 3000 };

export const BUS_CITIES = ["Abidjan", "Bouaké", "Yamoussoukro", "San-Pédro", "Korhogo", "Daloa", "Man"];

export const BUSES = [
  { id: "utb", company: "UTB", color: "#15803D", rating: "4,6", reviews: "1 245", dep: "08:00", arr: "12:30", duration: "4h30", price: 6000, direct: true, wifi: true, clim: true },
  { id: "sotra", company: "Sotra", color: "#166534", rating: "4,4", reviews: "980", dep: "10:30", arr: "15:00", duration: "4h30", price: 6500, direct: true, wifi: false, clim: true },
  { id: "stc", company: "STC", color: "#1D4ED8", rating: "4,5", reviews: "642", dep: "14:00", arr: "18:30", duration: "4h30", price: 7000, direct: true, wifi: true, clim: true },
  { id: "expb", company: "Express Bouaké", color: "#B45309", rating: "4,3", reviews: "320", dep: "18:30", arr: "23:00", duration: "4h30", price: 6000, direct: true, wifi: false, clim: true },
];

export const BUS_OPTIONS = { windowSeat: 500, frontSeat: 500, space: 1000, insurance: 500 };

export const PAY_METHODS = [
  { id: "orange", name: "Orange Money", bg: "#F97316", text: "OM" },
  { id: "mtn", name: "MTN Money", bg: "#FACC15", text: "MTN", dark: true },
  { id: "wave", name: "Wave", bg: "#2563EB", text: "wave" },
  { id: "card", name: "Carte bancaire", bg: "#334155", text: "CB" },
];

export const TAXI_PLACES = [
  { id: "riviera3", name: "Riviera 3 (Pharmacie St Viateur)", commune: "Cocody", km: 0 },
  { id: "plateau", name: "Plateau (Tour A)", commune: "Plateau", km: 4.8 },
  { id: "marcory", name: "Marcory Zone 4", commune: "Marcory", km: 7.2 },
  { id: "adjame", name: "Adjamé Liberté", commune: "Adjamé", km: 6.1 },
  { id: "treichville", name: "Treichville Avenue 16", commune: "Treichville", km: 5.4 },
  { id: "yopougon", name: "Yopougon Niangon", commune: "Yopougon", km: 12.4 },
  { id: "bingerville", name: "Bingerville Centre", commune: "Bingerville", km: 12.4 },
  { id: "airport", name: "Aéroport FHB (Port-Bouët)", commune: "Port-Bouët", km: 16.8 },
];

export const TAXI_TYPES = [
  { id: "standard", name: "Taxi standard", desc: "Compteur ou prix négocié", mult: 1 },
  { id: "confort", name: "Taxi confort", desc: "Véhicule récent, climatisé", mult: 1.4 },
  { id: "van", name: "Van familial", desc: "Jusqu'à 6 passagers", mult: 1.8 },
];

export const taxiEstimate = (km, mult = 1) => {
  const price = Math.round((500 + km * 350) * mult / 100) * 100;
  const minutes = Math.max(5, Math.round(km * 3));
  return { price, minutes };
};

// Sièges indisponibles fixes (mock déterministe — remplaçable par API disponibilité)
export const PLANE_TAKEN = new Set(["1B", "1C", "2E", "3A", "3F", "4D", "5B", "6C", "6E", "7A", "8F", "9B", "10D"]);
export const BUS_TAKEN = new Set(["02", "05", "09", "12"]);
